// extracted by mini-css-extract-plugin
export default {"container":"messagesearch_container__VxM4w"};